import { Button, EmptyState } from '@neshane/blueberry';
import { Component } from 'react';

class ErrorBoundaryKYC extends Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false, error: null };
    }

    static getDerivedStateFromError(error) {
        return { hasError: true, error };
    }

    componentDidCatch(error, errorInfo) {
        // eslint-disable-next-line no-console
        console.error(error, errorInfo);
    }

    handleReload = () => {
        window.location.reload();
    };

    render() {
        if (this.state.hasError) {
            return (
                <EmptyState
                    className="min-h-screen"
                    illustration={
                        <span className="text-[64px]" aria-hidden="true">
                            ⚠️
                        </span>
                    }
                    title="مشکلی پیش آمد"
                    subtitle="خطایی در بارگذاری این صفحه رخ داده است. لطفاً دوباره تلاش کنید."
                    actions={[
                        <Button
                            key="reload"
                            text="تلاش مجدد"
                            variant="primaryBrand"
                            onClick={this.handleReload}
                        />,
                    ]}
                />
            );
        }

        return this.props.children;
    }
}

export { ErrorBoundaryKYC };
